<template>
    <teleport to="#navigationSpot">
        <el-date-picker
            size="large"
            type="daterange"
            v-model="date"
            unlink-panels

            @visible-change="handleBlur"
            :range-separator="`${trans('t/m')}`"
            :start-placeholder="`${trans('Start datum')}`"
            :end-placeholder="`${trans('Eind datum')}`"
            :shortcuts="shortcuts"
        />
    </teleport>
</template>

<script>
import {defineComponent, inject, computed, ref} from "vue";
import {useRoute} from "vue-router";

import Icon from "components/icon";
import trans from "helpers/_translation";

import { startDate, endDate, setStartDate, setEndDate } from "store/statistics";

export default defineComponent({
    name: "part",
    components: {
        Icon
    },
    setup() {
        const route = useRoute();
        const viewData = inject("viewData");


        const shortcuts = [
            {
                text: trans('Laatste week'),
                value: () => {
                    const end = new Date()
                    const start = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                    return [start, end]
                },
            },
            {
                text: trans('Laatste maand'),
                value: () => {
                    const end = new Date()
                    const start = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                    return [start, end]
                },
            },
            {
                text: trans('Laatste 3 maanden'),
                value: () => {
                    const end = new Date()
                    const start = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                    return [start, end]
                },
            },
            {
                text: trans('Laatste 6 maanden'),
                value: () => {
                    const end = new Date()
                    const start = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
                    return [start, end]
                },
            },
            {
                text: trans('Laatste jaar'),
                value: () => {
                    const end = new Date()
                    const start = new Date()
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 365)
                    return [start, end]
                },
            }
        ];
        const date = ref([
            new Date(startDate.value),
            new Date(endDate.value)
        ]);

        const handleBlur = () => {
            if (date.value[0].toGMTString() !== startDate.value.toGMTString()) {
                setStartDate(date.value[0]);
            }
            if (date.value[1].toGMTString() !== endDate.value.toGMTString()) {
                setEndDate(date.value[1]);
            }
        };

        return {
            trans,
            route,
            viewData,

            shortcuts,
            date,

            handleBlur
        }
    }
});
</script>